<template>
    <b-card>
        <form @submit="save">
            <div class="row" v-for="(value, property) in sortedFields" :key="property">
                <div class="col-sm-12" v-if="value.visible">
                    <fieldset role="group" class="b-form-group form-group"><!---->
                    <div role="group" class="">
                        <IdentityFields :field="value" v-model="model[value.key]" @error="fieldError"/>
                    </div>
                    </fieldset>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-3">
                    <button type="submit" class="btn btn-success btn-block active" v-on:click="save">Save</button>
                </div>
                <div class="col-sm-3">
                    <button type="submit" class="btn btn-primary btn-block active" v-on:click="saveAndContinue">Save & Continue</button>
                </div>
            </div>
        </form>
    </b-card>
</template>

<script>
import _ from "lodash"

export default {
    name: "TableCustom_Create",
    components: {
        IdentityFields: () => import('../../../IdentityFields')
    },
    props: {
        fields: {
            type: Array,
            default: () => {
                return []
            }
        },

        translator: {
            type: Function
        }
    },
    data: () => {
        return {
            model: {},
            errors: [],
            actionModal: {
                processing: false,
                actionName: ''
            }
        }
    },
    computed: {
        sortedFields() {
            let fields = this.fields 

            fields.sort((a, b) => {
                return a.sortOrder - b.sortOrder
            })

            return fields
        },

        component() {
            let compUUID = this.$store.getters.currentComponent.uuid;

            return this.$store.getters.componentSettings(compUUID)
        }
    },
    methods: {
        fieldError(error) {
            let found = this.errors.find((i, e) => {
                return i.field == error.field
            })

            if (found === undefined) {
                this.errors.push(error)
            } else {
                this.errors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }
        },

        checkForErrors() {
            return this.errors.find((i, e) => {
                return i.error
            })
        },
        
        save(e) {
            e.preventDefault()
            
            if (this.checkForErrors()) {
                this.$bvModal.msgBoxOk(this.translator("fieldsNotValid"))

                return
            }

            this.$emit("onSave", this.model);
            this.model = {};
        },

        saveAndContinue(e) {
            e.preventDefault()
            
            if (this.checkForErrors()) {
                this.$bvModal.msgBoxOk(this.translator("fieldsNotValid"))

                return
            }

            this.$emit("onSaveAndContinue", this.model);
            this.model = {};
        }

    }
}
</script>